import { FunctionComponent } from "react";
import { SecaoButao } from "../../../../components/formulario/styled";
import ModalExportar from "../../../../components/modalExportar";
import OpenExcelUniversal from "../../../../components/excel/OpenExcelUniversal";
import DonwloadPdf from "../../../../components/pdf/DonwloadPdf";
import SearchInput from "../../../../components/inputs/searchInput";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { UseList } from "../context/getEvents";
import ModalFilter from "./modalFilter/modalFilter";
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';


interface HeaderEventosProps {

}

const HeaderEventos: FunctionComponent<HeaderEventosProps> = () => {

  const nav = useNavigate();

  const { listAll, getSearchByMinister } = UseList()

  return (<>
    <SecaoButao style={{ marginBottom: 5 }}>
      <section style={{ display: 'flex', gap: 5 }}>

        <ModalExportar
          callDownloadExcel={() => OpenExcelUniversal(listAll, ['nome_sede', 'nomeministerio', 'descricao', 'nome_cidade', 'inicio', 'fim', 'ativo', 'inscricao'])}
          callDownloadPdf={() => DonwloadPdf(listAll, ['Sede', 'Ministério', 'Evento', 'Cidade', 'Inicio', 'Termino', 'Ativo', 'Permite Inscrição?'],
            ['nome_sede', 'nomeministerio', 'descricao', 'nome_cidade', 'inicio', 'fim', 'ativo', 'inscricao'], listAll?.length, [], `${listAll?.length}`)
          }
        />

        <ModalFilter />

      </section>
      <SearchInput
        placeholder="Procure por evento ou ministério"
        onChange={getSearchByMinister} />

      <Button
        sx={{
          boxShadow: 'none', '@media (max-width: 600px)': {
            '> p': {
              display: 'none'
            }
          }
        }}
        variant="contained"
        startIcon={<AddBoxRoundedIcon />}
        onClick={() => nav('add')}
      >
        <p>
          Adicionar
        </p>
      </Button>
    </SecaoButao>
  </>);
}

export default HeaderEventos;
